/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import {
	withGoogleMap,
	GoogleMap
} from 'react-google-maps';
import Geocode from "react-geocode";
import PageLoading from '../../components/PageLoading';
import PlacesAutocomplete, {
	geocodeByAddress,
	getLatLng
} from 'react-places-autocomplete';

import { getDefValues, callApiV2, getPolygonsByCity, showError } from '../../common/functions';
import { toast } from 'mdbreact';

Geocode.setApiKey("AIzaSyD9QlvrLNSxDZWXffh5kSBDR7OjY1FSjr8");
Geocode.enableDebug();
Geocode.setRegion("es");
Geocode.setLanguage("es");

var mapRef;

class Map extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
			coords: null,
			address: '',
			coordValidation: [],
			width: 0,
			isLoading: false,
			zoom: 16
		};
	}

	componentDidMount() {
		this.setState({ width: "100%" });
		this.setState({ address: this.props.city + " " + this.props.address });

		Geocode.fromAddress(this.props.city + ", Bolivia " + this.props.address).then(
			response => {
				if (response.results.length > 0) {
					let lat = response.results[0].geometry.location.lat;
					let lng = response.results[0].geometry.location.lng;

					this.setState({
						coords: { lat, lng },
						address: response.results[0].formatted_address
					});
				} else {
					this.setState({ coords: this.props.coords });
				}
			},
			error => {
				this.setState({ coords: this.props.coords });
			}
		);
	}

	handleChange = address => {
		this.setState({ address });
	};

	handleSelect = address => {
		geocodeByAddress(address)
			.then(results => getLatLng(results[0]))
			.then(latLng => {
				this.setState({
					coords: latLng,
					address
				});
			})
			.catch(error => console.error('Error', error));
	};

	setMyLocation = async () => {
		await navigator.geolocation.getCurrentPosition(async (position) => {
			let lat = position.coords.latitude;
			let lng = position.coords.longitude;

			Geocode.fromLatLng(lat, lng).then(
				response => {
					const address = response.results[0].formatted_address;

					this.setState({
						address: address || '',
						coords: { lat, lng }
					});
				}
			);
		});
	}

	onMapDragEnd = () => {
		const newCenter = mapRef.getCenter().toJSON();

		Geocode.fromLatLng(newCenter.lat, newCenter.lng).then(
			response => {
				const address = response.results[0].formatted_address;

				this.setState({
					address: address || '',
					coords: newCenter
				});
			},
			error => console.error(error)
		);
	};

	confirmLocation = async () => {
		this.setState({ isLoading: true });

		try {
			let respC = await callApiV2("frontend", "checkCoords", {
				latitude: this.state.coords.lat.toFixed(5),
				longitude: this.state.coords.lng.toFixed(5),
				city: this.props.city
			});

			if (respC.success) {
				const data = {
					lat: this.state.coords.lat,
					lng: this.state.coords.lng,
					shippingCost: respC.result.price,
					zonecode: respC.result.code
				};
				this.props.confirmLocation(data);
			} else {
				showError(toast, getDefValues().outOfCoverageLabel);

				var coordsV = await getPolygonsByCity(this.props.city);
				var coordValidation = [];
				coordsV.map(key => {
					if (key.TYPE === "LIMIT") {
						coordValidation.push({ lat: key.LATITUDE, lng: key.LONGITUDE });
					}
				});
				this.setState({ coordValidation });
			}

			this.setState({ isLoading: false });
		} catch (Excep) {
			this.setState({ isLoading: false });
		}
	}

	render() {

		if (!this.state.coords) {
			return <PageLoading isLoading={true} />;
		}

		const GoogleMapContainer = withGoogleMap(props => (
			<GoogleMap
				ref={(ref) => (mapRef = ref)}
				zoom={this.state.zoom}
				defaultCenter={this.state.coords}
				onDragEnd={this.onMapDragEnd}
				onZoomChanged={() => {
					if (mapRef) {
						this.setState({ zoom: mapRef.getZoom() });
					}
				}}
			/>
		));

		return (
			<>
				<PageLoading isLoading={this.state.isLoading} />

				<div style={{ position: "relative", width: "100%" }}>

					{/* 🔎 AUTOCOMPLETE */}
					<PlacesAutocomplete
						value={this.state.address}
						onChange={this.handleChange}
						onSelect={this.handleSelect}
					>
						{({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
							<div style={{ padding: "8px" }}>
								<input
									{...getInputProps({
										placeholder: 'Buscar dirección...',
										className: 'form-control'
									})}
								/>

								<div className="autocomplete-dropdown-container">
									{loading && <div>{getDefValues().loadingLabel}</div>}
									{suggestions.map(suggestion => {
										const className = suggestion.active
											? 'suggestion-item--active'
											: 'suggestion-item';
										const style = suggestion.active
											? { backgroundColor: '#fafafa', cursor: 'pointer' }
											: { backgroundColor: '#fff', cursor: 'pointer' };
										return (
											<div
												{...getSuggestionItemProps(suggestion, { className, style })}
												key={suggestion.placeId}
											>
												<span>{suggestion.description}</span>
											</div>
										);
									})}
								</div>
							</div>
						)}
					</PlacesAutocomplete>

					{/* 🗺️ MAPA */}

					<div class="disclaimer-box">
						<p>📍 Puede mover el mapa para ajustar la ubicación con mayor precisión.{this.props.height}</p>
					</div>

					<GoogleMapContainer
						containerElement={<div style={{ height: this.props.height, width: "100%" }} />}
						mapElement={<div style={{ height: "100%", width: "100%" }} />}
					/>

					{/* 📌 PIN FIJO (estilo PedidosYa) */}
					<div
						style={{
							position: "absolute",
							top: "50%",
							left: "50%",
							transform: "translate(-50%, -100%)",
							zIndex: 10,
							pointerEvents: "none"
						}}
					>
						<img
							src="https://cdn-icons-png.flaticon.com/512/684/684908.png"
							style={{ width: 55, height: 55 }}
							alt="pin"
						/>
					</div>

					{/* 📍 BOTÓN CENTRAR */}
					<button
						onClick={this.setMyLocation}
						style={{
							position: "absolute",
							bottom: "140px",
							right: "15px",
							zIndex: 20,
							background: "white",
							borderRadius: "50%",
							width: 50,
							height: 50,
							border: "0px",
							boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
							cursor: "pointer",
							fontSize: "20px"
						}}
					>
						📍
					</button>

					{/* 🟥 BOTTOM SHEET ESTILO PEDIDOS YA */}
					<div
						style={{
							bottom: 0,
							width: "100%",
							background: "#fff",
							padding: "20px",
							borderTopLeftRadius: "16px",
							borderTopRightRadius: "16px",
							boxShadow: "0 -4px 12px rgba(0,0,0,0.15)",
							zIndex: 30
						}}
					>
						<div style={{ color: "#666", fontSize: "14px" }}>
							Dirección seleccionada
						</div>

						<div style={{ fontSize: "17px", fontWeight: "bold", marginTop: "4px" }}>
							{this.state.address}
						</div>


						<div className="card">
							<div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 flex items-center mt-1">
								<button
									className={"btn mr-1 btn-outline-" + (this.props.btncolor ? this.props.btncolor : "primary")}
									type="button"
									onClick={this.props.backLocation}
								>
									<i style={{ fontSize: "15px" }} className="fas fa-chevron-left" />
								</button>

								<button
									className={"btn btn-md mr-1 btn-" + (this.props.btncolor ? this.props.btncolor : "primary")}
									type="button"
									onClick={this.confirmLocation}
								>
									{getDefValues().confirmLocationLabel}
								</button>

								<button
									className={"btn btn-md btn-outline-" + (this.props.btncolor ? this.props.btncolor : "primary")}
									type="button"
									onClick={this.props.cancelLocation}
								>
									{getDefValues().cancelLabel}
								</button>
							</div>
						</div>

					</div>
				</div>
			</>
		);
	}
}

export default Map;
